var NewInstanceResolver_1;
import * as tslib_1 from "tslib";
import { containerResolver } from '../protocol/resolver';
import { Strategy } from '../types';
/**
 * Used to inject a new instance of a dependency, without regard for existing
 * instances in the container. Instances can optionally be registered in the container
 * under a different key by supplying a key using the `as` method.
 */
let NewInstanceResolver = NewInstanceResolver_1 = class NewInstanceResolver {
    /**
     * Creates an instance of the NewInstance class.
     * @param key The key to resolve/instantiate.
     * @param dynamicDependencies An optional list of dynamic dependencies.
     */
    constructor(key, ...dynamicDependencies) {
        this._key = key;
        this._asKey = key;
        this._dynamicDependencies = dynamicDependencies;
    }
    /**
     * Creates an NewInstance Resolver for the supplied key.
     * @param key The key to resolve/instantiate.
     * @param dynamicDependencies An optional list of dynamic dependencies.
     * @return Returns an instance of NewInstance for the key.
     */
    static of(key, ...dynamicDependencies) {
        return new NewInstanceResolver_1(key, ...dynamicDependencies);
    }
    /**
     * Called by the container to instantiate the dependency and potentially register
     * as another key if the `as` method was used.
     * @param container The container to resolve the parent from.
     * @return Returns the matching instance from the parent container
     */
    get(container, key) {
        const dynamicDependencies = this._dynamicDependencies.length > 0
            ? this._dynamicDependencies.map(dependency => dependency['protocol:aurelia:resolver']
                ? dependency.get(container)
                : container.get(dependency))
            : undefined;
        let _key = this._key;
        const resolver = container.getResolver(_key);
        if (resolver && resolver.strategy === Strategy.Function) {
            _key = resolver.state;
        }
        const instance = container.invoke(_key, dynamicDependencies);
        container.registerInstance(this._asKey, instance);
        return instance;
    }
    /**
     * Instructs the NewInstance resolver to register the resolved instance using the supplied key.
     * @param key The key to register the instance with.
     * @return Returns the NewInstance resolver.
     */
    as(key) {
        this._asKey = key;
        return this;
    }
};
NewInstanceResolver = NewInstanceResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Object, Object])
], NewInstanceResolver);
export { NewInstanceResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmV3SW5zdGFuY2VSZXNvbHZlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk5ld0luc3RhbmNlUmVzb2x2ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFPQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUN6RCxPQUFPLEVBQWdDLFFBQVEsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUVsRTs7OztHQUlHO0FBRUgsSUFBYSxtQkFBbUIsMkJBQWhDLE1BQWEsbUJBQW1CO0lBa0I1Qjs7OztPQUlHO0lBQ0gsWUFBbUIsR0FBVyxFQUFFLEdBQUcsbUJBQTBCO1FBQ3pELElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO1FBQ2hCLElBQUksQ0FBQyxNQUFNLEdBQUcsR0FBVSxDQUFDO1FBQ3pCLElBQUksQ0FBQyxvQkFBb0IsR0FBRyxtQkFBbUIsQ0FBQztJQUNwRCxDQUFDO0lBMUJEOzs7OztPQUtHO0lBQ0ksTUFBTSxDQUFDLEVBQUUsQ0FBSSxHQUFXLEVBQUUsR0FBRyxtQkFBMEI7UUFDMUQsT0FBTyxJQUFJLHFCQUFtQixDQUFJLEdBQUcsRUFBRSxHQUFHLG1CQUFtQixDQUFDLENBQUM7SUFDbkUsQ0FBQztJQW9CRDs7Ozs7T0FLRztJQUNJLEdBQUcsQ0FBQyxTQUFvQixFQUFFLEdBQVc7UUFDeEMsTUFBTSxtQkFBbUIsR0FDckIsSUFBSSxDQUFDLG9CQUFvQixDQUFDLE1BQU0sR0FBRyxDQUFDO1lBQ2hDLENBQUMsQ0FBQyxJQUFJLENBQUMsb0JBQW9CLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQyxFQUFFLENBQ3ZDLFVBQVUsQ0FBQywyQkFBMkIsQ0FBQztnQkFDbkMsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDO2dCQUMzQixDQUFDLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUMsQ0FDbEM7WUFDSCxDQUFDLENBQUMsU0FBUyxDQUFDO1FBRXBCLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUM7UUFDckIsTUFBTSxRQUFRLEdBQUcsU0FBUyxDQUFDLFdBQVcsQ0FBQyxJQUFXLENBQUMsQ0FBQztRQUNwRCxJQUFJLFFBQVEsSUFBSyxRQUFnQixDQUFDLFFBQVEsS0FBSyxRQUFRLENBQUMsUUFBUSxFQUFFO1lBQzlELElBQUksR0FBSSxRQUFnQixDQUFDLEtBQUssQ0FBQztTQUNsQztRQUVELE1BQU0sUUFBUSxHQUFHLFNBQVMsQ0FBQyxNQUFNLENBQUksSUFBVyxFQUFFLG1CQUFtQixDQUFDLENBQUM7UUFDdkUsU0FBUyxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFFbEQsT0FBTyxRQUFRLENBQUM7SUFDcEIsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxFQUFFLENBQUMsR0FBVztRQUNqQixJQUFJLENBQUMsTUFBTSxHQUFHLEdBQUcsQ0FBQztRQUVsQixPQUFPLElBQUksQ0FBQztJQUNoQixDQUFDO0NBQ0osQ0FBQTtBQW5FWSxtQkFBbUI7SUFEL0IsaUJBQWlCOztHQUNMLG1CQUFtQixDQW1FL0I7U0FuRVksbUJBQW1CIn0=